import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { SvgIcon, Typography } from '@material-ui/core';
import userIcon from '../../../icons/user.svg';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY ,SESSION_STORAGE_BASIC_INFO_KEY } from '../../../sessionStorage';
import moment from 'moment';
import './ThankYou.scss';
import CalendarIcon from '../../../icons/calendar.svg';
import GetStateLabel from '../../Helpers/Lists/GetStateLabel';

export default function ThankYou(props) {
    const [name, setName] = useState();
    var phone = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.phone
    var day = new moment(props.date);
    useEffect(() => {
        setName(props.name);
        // clear product 
      sessionStorage.removeItem(props.sessionStorageKey)
    }, [])

    return (
        <div className="thank-you-section">
            <Container >
                <Row>
                    <Col lg={8} className='main'>
                        <div className='thankyou-image'>
                        </div>
                        <Row className="mt-5">
                            <SvgIcon color='primary' component={CalendarIcon} className="icons" fontSize="large" />
                        </Row>
                        <Row className="mt-2">
                            <p className="name">Thanks {name}! <br /> <span>Look for a call from this number:</span></p>
                        </Row>
                        <Row>
                            <Typography color="primary" variant="h5">{phone}</Typography>
                        </Row>
                        {props.date && (
                            <React.Fragment>
                                <Row>
                                    <Typography color="primary" variant="h5">{day.format('dddd, MMMM D')}</Typography>
                                </Row>
                                <Row>
                                <Typography color="primary" variant="h5">at {day.format('hh:mm A')}</Typography>
                                </Row>
                            </React.Fragment>
                        )}
                        <Row className="mt-3">
                            <p className="expect">Here's what to expect. <br />
                                <span>
                                    One of our {GetStateLabel(props.basicInfo.state)} licensed insurance specialists will:
                                </span>
                            </p>
                        </Row>
                        <Row>
                            <ul>
                                <li>Confirm your information</li>
                                <li>Collect beneficiary details</li>
                                <li>Finalize your coverage</li>
                            </ul>
                        </Row>
                        <Row className="mt-2">
                            <SvgIcon color='primary' component={userIcon} className="icons" fontSize="large" />
                        </Row>
                        <Row className="mt-2">
                            <p className="coverage">We look forward to completing your coverage!</p>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

ThankYou.propTypes = {
    sessionStorageKey: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/ThankYou.js